// Note that the order cannot be changed to make sure the data report is correct

export enum TimeChangeActionType {
    QuickComposeTimeControls = 1,
    FullComposeTimeControls = 2,
    SchedulingAssistantTimeControls = 3,
    SchedulingAssistantResizeAvailabilityBox = 4,
    SchedulingAssistantMoveAvailabilityBox = 5,
    SchedulingAssistantSaveChanges = 6,
    SchedulingAssistantDiscardChanges = 7,
    SchedulingAssistantProposeNewTimeCurrentTime = 8,
    SchedulingAssistantProposeNewTimeSuggestedTime = 9,
    SchedulingGrid = 10,
    TimeSuggestions = 11,
    FullComposeProposeNewTimeCurrentTime = 12,
    FullComposeProposeNewTimeSuggestedTime = 13,
    GuidedCapture = 14,
    CustomRecurrence = 15,
    AddinsStartTime = 16,
    AddinsEndTime = 17,
    SchedulingGridBrowseBackward = 18,
    SchedulingGridBrowseForward = 19,
    SchedulingGridBrowseDate = 20,
    SchedulingAssistantScroll = 21,
    TimeSuggestionsSearchCriteria = 22,
    AddinsTimeZone = 23,
    SchedulingGridBrowseToday = 24,
}
